// export const esData = {
//   title: "Política de Privacidad y Cookies – Danghuan",
//   sections: [
//     {
//       title: "Introducción",
//       content: `
//         <p>Esta Política de Privacidad y Cookies explica cómo Danghuan Europe S.L. ('nosotros', 'nos' o 'Danghuan') recopila, utiliza y protege sus datos personales cuando interactúa con nuestros sitios web y servicios. Esta política se aplica a los residentes del Espacio Económico Europeo (EEE) y del Reino Unido (UK), y cumple con el Reglamento General de Protección de Datos (GDPR) y el GDPR del Reino Unido.</p>
//       `
//     },
//     {
//       title: "Scope of this Policy",
//       content: `
//         <p>Esta Política se aplica a:</p>
//         <ul>
//           <li>Visitantes de nuestro sitio web</li>
//           <li>Clientes y clientes potenciales</li>
//           <li>Usuarios de nuestros servicios de recompra y reventa</li>
//           <li>Representantes de socios comerciales y afiliados de plataformas</li>
//         </ul>
//       `
//     },
//     {
//       title: "What Data We Collect",
//       content: `
//         <p>Dependiendo de su interacción con nosotros, podemos recopilar:</p>
//         <ul>
//           <li>Nombre completo, dirección, correo electrónico y número de teléfono</li>
//           <li>IBAN, código de sucursal y número de cuenta, PayPal, Revolut u otros datos bancarios</li>
//           <li>Detalles del dispositivo (modelo, marca, estado, información de precios, IMEI)</li>
//           <li>Historial de comunicaciones con el servicio al cliente</li>
//           <li>Preferencias de marketing e interacciones con campañas</li>
//           <li>Dirección IP, tipo de navegador, ID de sesión y ubicación</li>
//           <li>Datos de plataformas como Shopify, Amazon, TEMU, Back Market</li>
//         </ul>
//         <p>También podemos recibir ciertos datos sobre usted de nuestros socios de plataforma o logística (por ejemplo, Shopify, Amazon, Back Market, TEMU) cuando interactúe con sus plataformas en relación con nuestros servicios. Esto incluye datos de pedidos, dirección de envío y estado de la transacción.</p>
//       `
//     },
//     {
//       title: "Use of Personal Data",
//       content: `
//         <p>Utilizamos sus datos para:</p>
//         <ul>
//           <li>Procesar pedidos y gestionar la logística (incluyendo devoluciones y recompras)</li>
//           <li>Comunicarnos con usted sobre sus transacciones</li>
//           <li>Proporcionar servicio al cliente y soporte</li>
//           <li>Enviar comunicaciones de marketing (si ha dado su consentimiento)</li>
//           <li>Cumplir con obligaciones legales (por ejemplo, verificaciones fiscales o antifraude)</li>
//           <li>Mejorar la experiencia del usuario y optimizar nuestras plataformas</li>
//         </ul>
//       `
//     },
//     {
//       title: "Cookies",
//       content: `
//         <p>Utilizamos cookies para mejorar su experiencia de navegación y nuestros servicios. Las cookies pueden recopilar:</p>
//         <ul>
//           <li>Dirección IP y geolocalización</li>
//           <li>Identificadores del navegador/dispositivo</li>
//           <li>Comportamiento de uso (páginas visitadas, tiempo en el sitio, clics)</li>
//         </ul>
//         <p>Tipos de cookies:</p>
//         <ul>
//           <li>Cookies estrictamente necesarias</li>
//           <li>Cookies funcionales</li>
//           <li>Cookies de rendimiento</li>
//           <li>Cookies de publicidad</li>
//         </ul>
//         <p>Puede configurar o revocar la configuración de cookies en cualquier momento a través de su navegador o del banner de cookies.</p>
//       `
//     },
//     {
//       title: "Third Parties We Share Data With",
//       content: `
//         <p>Compartimos datos con socios de pagos y logística por necesidad contractual; y con proveedores de análisis según su consentimiento de cookies.</p>
//         <p>Podemos compartir sus datos con:</p>
//         <ul>
//           <li>Socios de pago: PayPal, Revolut, VISA, Mastercard, Stripe</li>
//           <li>Proveedores logísticos: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
//           <li>Plataformas asociadas: Shopify, Amazon, TEMU, BackMarket</li>
//           <li>Proveedores de marketing y análisis: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
//           <li>Proveedores de TI, consultores, asesores legales</li>
//           <li>Autoridades gubernamentales si lo exige la ley</li>
//         </ul>
//         <p>Los datos pueden transferirse fuera del EEE/Reino Unido bajo salvaguardias aprobadas por la UE, como las Cláusulas Contractuales Estándar.</p>
//       `
//     },
//     {
//       title: "Use of Third-Party Brand Logos",
//       content: `
//         <p>Nuestro sitio web muestra nombres y logotipos de marcas como Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google y otras únicamente para identificar dispositivos compatibles con nuestros servicios de recompra o reventa. Todas las marcas comerciales pertenecen a sus respectivos propietarios. Danghuan Europe es un proveedor de servicios independiente y no está afiliado, respaldado o patrocinado por estas marcas a menos que se indique explícitamente. La presencia de estos logotipos no implica ninguna relación comercial formal.</p>
//         <p>El uso de logotipos de marcas de terceros es únicamente con fines descriptivos. Todas estas marcas conservan sus respectivos derechos, y no se implica ninguna asociación con Danghuan.</p>
//       `
//     },
//     {
//       title: "Data Retention and Security",
//       content: `
//         <p>Conservamos sus datos solo durante el tiempo necesario para cumplir con los fines mencionados anteriormente o según lo requiera la ley. Implementamos medidas técnicas y organizativas adecuadas para proteger sus datos, incluyendo encriptación, control de acceso y almacenamiento seguro.</p>
//       `
//     },
//     {
//       title: "Your Rights",
//       content: `
//         <p>Nos comprometemos a responder a todas las solicitudes de datos válidas dentro de un mes. Para proteger su privacidad, es posible que necesitemos verificar su identidad antes de procesar su solicitud.</p>
//         <p>Tiene derecho a:</p>
//         <ul>
//           <li>Acceder y rectificar sus datos</li>
//           <li>Solicitar la eliminación ('derecho al olvido')</li>
//           <li>Oponerse o restringir el procesamiento</li>
//           <li>Retirar su consentimiento en cualquier momento</li>
//           <li>Solicitar la portabilidad de datos (cuando sea aplicable)</li>
//         </ul>
//         <p>Para ejercer estos derechos, contáctenos en <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
//       `
//     },
//     {
//       title: "Policy Updates",
//       content: `
//         <p>Podemos actualizar esta Política para reflejar cambios en los requisitos legales o en nuestras prácticas de datos. La versión más reciente siempre estará disponible en nuestro sitio web.</p>
//       `
//     },
//     {
//       title: "Contact Us",
//       content: `
//         <p>Si tiene preguntas o desea ejercer sus derechos, contáctenos:</p>
//         <ul>
//           <li>Danghuan Europe S.L.</li>
//           <li>Correo electrónico: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
//           <li>Sitio web: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
//         </ul>
//         <p>También puede presentar una queja ante su autoridad local de protección de datos o ante la Agencia Española de Protección de Datos (AEPD).</p>
//       `
//     },
//     {
//       title: "Addendum – Extended Legal and Cookie Information",
//       subsections: [
//         {
//           title: "1. Legal Basis for Data Processing",
//           content: `
//             <p>La base legal para el procesamiento de sus datos personales incluye:</p>
//             <ul>
//               <li>Ejecución de un contrato (por ejemplo, procesamiento de pedidos de recompra, envío de pagos)</li>
//               <li>Cumplimiento de obligaciones legales (por ejemplo, informes fiscales, verificación de identidad)</li>
//               <li>Su consentimiento (por ejemplo, comunicaciones de marketing o cookies de terceros)</li>
//               <li>Intereses legítimos (por ejemplo, prevención de fraude, análisis internos, mejora del servicio)</li>
//             </ul>
//           `
//         },
//         {
//           title: "2. Fraud Prevention Measures",
//           content: `
//             <p>Podemos utilizar su información personal (por ejemplo, número de serie del dispositivo, patrón de transacción, geolocalización por IP, titularidad del IBAN) para realizar detección de fraude utilizando bases de datos públicas y proveedores de servicios antifraude. Esto se realiza en virtud de nuestro interés legítimo en prevenir el robo de identidad y el uso indebido de nuestros servicios.</p>
//             <p>No tomamos decisiones basadas exclusivamente en el procesamiento automatizado que le afecten significativamente.</p>
//           `
//         },
//         {
//           title: "3. Data Handling on External Marketplaces",
//           content: `
//             <p>Si compra o vende dispositivos a través de plataformas de terceros como Amazon, Shopify, TEMU o Back Market, Danghuan puede recibir su información de pedido, dirección de envío y confirmación de pago a través de API cifrada o canal seguro de back-office, únicamente con el propósito de cumplir con su transacción y brindar soporte postventa.</p>
//           `
//         },
//         {
//           title: "4. Cookie Categories and Details",
//           content: `
//             <p>Puede revisar la lista completa de cookies que utilizamos, incluido el nombre, proveedor, propósito, duración y tipo (propias o de terceros) en la siguiente tabla. Esto incluye cookies de análisis de Google Analytics, cookies de remarketing de Meta y cookies de pago de PayPal.</p>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Categoría</th>
//                   <th>Nombre de la cookie</th>
//                   <th>Proveedor</th>
//                   <th>Propósito</th>
//                   <th>Duración</th>
//                   <th>Tipo</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Estrictamente necesarias</td>
//                   <td>Opismo/Consent</td>
//                   <td>danghuan.eu</td>
//                   <td>Guarda las preferencias de cookies</td>
//                   <td>1 año</td>
//                   <td>Propias</td>
//                 </tr>
//                 <tr>
//                   <td>Estrictamente necesarias</td>
//                   <td>session_id</td>
//                   <td>danghuan.eu</td>
//                   <td>Mantiene el estado de la sesión entre páginas</td>
//                   <td>Sesión</td>
//                   <td>Propias</td>
//                 </tr>
//                 <tr>
//                   <td>Funcionales</td>
//                   <td>i1@next</td>
//                   <td>danghuan.eu</td>
//                   <td>Recuerda la preferencia de idioma seleccionada</td>
//                   <td>Sesión</td>
//                   <td>Propias</td>
//                 </tr>
//                 <tr>
//                   <td>Funcionales</td>
//                   <td>live_chat</td>
//                   <td>Tawk.io</td>
//                   <td>Habilita el soporte de chat en vivo</td>
//                   <td>8 meses</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Rendimiento</td>
//                   <td>_ga</td>
//                   <td>Google Analytics</td>
//                   <td>Recopila estadísticas de uso del sitio</td>
//                   <td>2 años</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Rendimiento</td>
//                   <td>_gid</td>
//                   <td>Google Analytics</td>
//                   <td>Rastrea el comportamiento del usuario entre sesiones</td>
//                   <td>24 horas</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Rendimiento</td>
//                   <td>_clck</td>
//                   <td>Microsoft Clarity</td>
//                   <td>Mantiene la sesión del usuario entre páginas</td>
//                   <td>1 año</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Publicidad</td>
//                   <td>_fbp</td>
//                   <td>Meta (Facebook)</td>
//                   <td>Muestra anuncios personalizados basados en el comportamiento</td>
//                   <td>3 meses</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Publicidad</td>
//                   <td>_t_enable_cookie</td>
//                   <td>TikTok</td>
//                   <td>Rastrea interacciones y conversiones del usuario</td>
//                   <td>13 meses</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Publicidad</td>
//                   <td>_uetsid</td>
//                   <td>Bing</td>
//                   <td>Rastrea usuarios entre sitios web para marketing</td>
//                   <td>1 día</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Publicidad</td>
//                   <td>_gd_su</td>
//                   <td>Google Ads</td>
//                   <td>Se utiliza para el seguimiento de conversiones</td>
//                   <td>3 meses</td>
//                   <td>Terceros</td>
//                 </tr>
//                 <tr>
//                   <td>Publicidad</td>
//                   <td>_kla_id</td>
//                   <td>Klaviyo</td>
//                   <td>Identifica visitantes para campañas de email marketing</td>
//                   <td>2 años</td>
//                   <td>Terceros</td>
//                 </tr>
//               </tbody>
//             </table>
//           `
//         },
//         {
//           title: "5. Promotions, Campaigns and Surveys",
//           content: `
//             <p>Cuando participe en nuestras promociones, encuestas o concursos, podemos recopilar su nombre, datos de contacto e información adicional específica del evento (por ejemplo, edad, ubicación). Estos datos se utilizan únicamente para administrar el evento, contactar a los ganadores y mejorar futuras campañas.</p>
//           `
//         },
//         {
//           title: "6. Supervisory Authorities",
//           content: `
//             <p>Puede presentar una queja ante las siguientes autoridades de supervisión si considera que se han violado sus derechos de protección de datos:</p>
//             <ul>
//               <li>En España: Agencia Española de Protección de Datos (AEPD) – <a href="https://www.aepd.es" target="_blank">www.aepd.es</a></li>
//               <li>En el Reino Unido: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
//               <li>En la Unión Europea: puede encontrar la autoridad nacional de supervisión correspondiente a su país en el sitio web del Comité Europeo de Protección de Datos (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
//             </ul>
//           `
//         }
//       ]
//     }
//   ],
//   footer: `
//     <p>© 2025 DANGHUAN EUROPE S.L. Todos los derechos reservados.<br>
//     Versión de la política: v1.0 | Última actualización: 30/05/2025</p>
//   `
// };

export const esData = {
  title: "Política de Privacidad y Cookies – Danghuan",
  sections: [
    {
      title: "Introducción",
      content: `
        <p>Esta Política de Privacidad y Cookies explica cómo Danghuan Europe S.L. ('nosotros' o 'Danghuan') recopila, utiliza y protege sus datos personales cuando interactúa con nuestros sitios web y servicios. Esta política se aplica a los residentes del Espacio Económico Europeo (EEE) y del Reino Unido (UK), y cumple con el Reglamento General de Protección de Datos (GDPR) y el GDPR del Reino Unido.</p>
      `
    },
    {
      title: "Ámbito de Aplicación",
      content: `
        <p>Esta Política se aplica a:</p>
        <ul>
          <li>Visitantes de nuestro sitio web (https://www.danghuan.eu).</li>
          <li>Clientes y clientes potenciales.</li>
          <li>Usuarios de nuestros servicios de recompra y reventa.</li>
          <li>Representantes de socios comerciales y afiliados de plataformas.</li>
        </ul>
      `
    },
    {
      title: "Datos que Recopilamos",
      content: `
        <p>Dependiendo de su interacción con nosotros, podemos recopilar:</p>
        <ul>
          <li>Nombre completo, dirección, correo electrónico y número de teléfono.</li>
          <li>IBAN, código de sucursal y número de cuenta, PayPal, Revolut u otros datos bancarios.</li>
          <li>Detalles del dispositivo (modelo, marca, estado, precio, IMEI).</li>
          <li>Historial de comunicaciones con atención al cliente.</li>
          <li>Preferencias de marketing e interacciones con campañas.</li>
          <li>Dirección IP, tipo de navegador, ID de sesión y ubicación.</li>
          <li>Datos de plataformas como Shopify, Amazon, TEMU, Back Market.</li>
        </ul>
        <p>También podemos recibir ciertos datos sobre usted de nuestros socios logísticos o de plataforma (por ejemplo, Shopify, Amazon, Back Market, TEMU) cuando interactúe con sus plataformas en relación con nuestros servicios. Esto incluye datos de pedido, dirección de envío y estado de la transacción.</p>
      `
    },
    {
      title: "Uso de Datos Personales",
      content: `
        <p>Utilizamos sus datos para:</p>
        <ul>
          <li>Procesar pedidos y gestionar la logística (incluidas devoluciones y recompras).</li>
          <li>Comunicarnos con usted sobre sus transacciones.</li>
          <li>Proporcionar atención al cliente y soporte.</li>
          <li>Enviar comunicaciones de marketing (si usted lo ha consentido).</li>
          <li>Cumplir con obligaciones legales (por ejemplo, informes fiscales o controles antifraude).</li>
          <li>Mejorar la experiencia del usuario y optimizar nuestras plataformas.</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Utilizamos cookies para mejorar su experiencia de navegación y nuestros servicios. Las cookies pueden recopilar:</p>
        <ul>
          <li>Dirección IP y geolocalización.</li>
          <li>Identificadores del navegador o del dispositivo.</li>
          <li>Comportamiento de uso (páginas vistas, tiempo en el sitio, clics).</li>
        </ul>
        <p>Tipos de cookies utilizadas:</p>
        <ul>
          <li>Cookies estrictamente necesarias</li>
          <li>Cookies funcionales</li>
          <li>Cookies de rendimiento</li>
          <li>Cookies de publicidad</li>
        </ul>
        <p>Puede configurar o revocar sus preferencias de cookies en cualquier momento a través de su navegador o del banner de cookies.</p>
      `
    },
    {
      title: "Terceros con los que Compartimos Datos",
      content: `
        <p>Compartimos datos con socios de pagos y logística por necesidad contractual; y con proveedores de análisis según su consentimiento de cookies.</p>
        <p>Podemos compartir sus datos con:</p>
        <ul>
          <li>Socios de pago: PayPal, Revolut, VISA, Mastercard, Stripe.</li>
          <li>Proveedores logísticos: UPS, Correos, DPD, Royal Mail, NACEX, FedEx.</li>
          <li>Plataformas: Shopify, Amazon, TEMU, BackMarket.</li>
          <li>Proveedores de marketing y análisis: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn.</li>
          <li>Proveedores de TI, consultores, asesores legales.</li>
          <li>Autoridades gubernamentales si así lo exige la ley.</li>
        </ul>
        <p>Los datos pueden transferirse fuera del EEE/Reino Unido bajo salvaguardas aprobadas por la UE, como las Cláusulas Contractuales Tipo.</p>
      `
    },
    {
      title: "Uso de Logotipos de Marcas de Terceros",
      content: `
        <p>Nuestro sitio web muestra nombres y logotipos de marcas como Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google y otras, únicamente para identificar dispositivos compatibles con nuestros servicios de recompra o reventa. Todas las marcas son propiedad de sus respectivos dueños. Danghuan Europe es un proveedor independiente y no está afiliado ni respaldado por estas marcas, salvo indicación expresa.</p>
        <p>La utilización de estos logotipos es meramente descriptiva. Todas las marcas conservan sus derechos y no existe ninguna asociación implícita con Danghuan.</p>
      `
    },
    {
      title: "Conservación y Seguridad de los Datos",
      content: `
        <p>Conservamos sus datos solo durante el tiempo necesario para cumplir con los fines anteriores o cuando lo exija la ley. Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos, incluida la encriptación, el control de acceso y el almacenamiento seguro.</p>
      `
    },
    {
      title: "Sus Derechos",
      content: `
        <p>Nos comprometemos a responder a todas las solicitudes válidas en el plazo de un mes. Para proteger su privacidad, podemos requerir verificación de identidad antes de procesar su solicitud.</p>
        <p>Usted tiene derecho a:</p>
        <ul>
          <li>Acceder y rectificar sus datos.</li>
          <li>Solicitar su eliminación ('derecho al olvido').</li>
          <li>Oponerse o restringir el procesamiento.</li>
          <li>Retirar su consentimiento en cualquier momento.</li>
          <li>Solicitar la portabilidad de los datos (cuando sea aplicable).</li>
        </ul>
        <p>Para ejercer estos derechos, contáctenos en: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Actualizaciones de la Política",
      content: `
        <p>Podemos actualizar esta Política para reflejar cambios legales o en nuestras prácticas de tratamiento. La versión más reciente estará siempre disponible en nuestro sitio web.</p>
      `
    },
    {
      title: "Contacto",
      content: `
        <p>Si tiene preguntas o desea ejercer sus derechos, contáctenos en:</p>
        <ul>
          <li>Danghuan Europe S.L.</li>
          <li>Correo electrónico: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li>Sitio web: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>También puede presentar una reclamación ante su autoridad de protección de datos local o ante la Agencia Española de Protección de Datos (AEPD).</p>
      `
    },
    {
      title: "Anexo – Información Adicional sobre Base Legal y Cookies",
      subsections: [
        {
          title: "1. Base Legal para el Tratamiento de Datos",
          content: `
            <p>La base legal para tratar sus datos personales incluye:</p>
            <ul>
              <li>Ejecución de un contrato (por ejemplo, procesamiento de pedidos de recompra, envío de pagos).</li>
              <li>Cumplimiento de obligaciones legales (por ejemplo, declaraciones fiscales, verificación de identidad).</li>
              <li>Su consentimiento (por ejemplo, comunicaciones de marketing o cookies de terceros).</li>
              <li>Intereses legítimos (por ejemplo, prevención del fraude, análisis internos, mejora del servicio).</li>
            </ul>
          `
        },
        {
          title: "2. Medidas de Prevención del Fraude",
          content: `
            <p>Podemos utilizar su información personal (por ejemplo, número de serie del dispositivo, patrón de transacción, geolocalización IP, titularidad del IBAN) para realizar detección de fraude utilizando bases de datos públicas y proveedores de servicios antifraude. Esto se realiza bajo nuestro interés legítimo en prevenir el robo de identidad y el uso indebido de nuestros servicios.</p>
            <p>No tomamos decisiones basadas exclusivamente en el procesamiento automatizado que le afecten significativamente.</p>
          `
        },
        {
          title: "3. Gestión de Datos en Plataformas Externas",
          content: `
            <p>Si compra o vende dispositivos a través de plataformas de terceros como Amazon, Shopify, TEMU o BackMarket, Danghuan Europe puede recibir su información de pedido, dirección de envío y confirmación de pago mediante API cifrada o canal seguro interno, exclusivamente con el fin de completar su transacción y brindar soporte postventa.</p>
          `
        },
        {
          title: "4. Categorías y Detalles de Cookies",
          content: `
            <p>Puede consultar la lista completa de cookies que utilizamos — incluyendo el nombre, proveedor, propósito, duración y tipo (primera o tercera parte) — en la tabla incluida a continuación. Esta incluye cookies analíticas de Google Analytics, cookies de remarketing de Meta, y cookies de pago de PayPal.</p>
            <table>
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Nombre</th>
                  <th>Proveedor</th>
                  <th>Propósito</th>
                  <th>Duración</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Estrictamente necesarias</td>
                  <td>session_id</td>
                  <td>danghuan.eu</td>
                  <td>Mantener sesión de usuario</td>
                  <td>Sesión</td>
                  <td>Primera parte</td>
                </tr>
                <tr>
                  <td>Funcionales</td>
                  <td>language_pref</td>
                  <td>danghuan.eu</td>
                  <td>Recordar preferencia de idioma</td>
                  <td>1 año</td>
                  <td>Primera parte</td>
                </tr>
                <tr>
                  <td>Rendimiento</td>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>Análisis de tráfico</td>
                  <td>2 años</td>
                  <td>Tercera parte</td>
                </tr>
                <tr>
                  <td>Publicidad</td>
                  <td>_fbp</td>
                  <td>Meta (Facebook)</td>
                  <td>Publicidad dirigida</td>
                  <td>3 meses</td>
                  <td>Tercera parte</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Promociones, Campañas y Encuestas",
          content: `
            <p>Cuando participe en nuestras promociones, encuestas o concursos, podemos recopilar su nombre, datos de contacto y otra información adicional específica del evento (por ejemplo, edad, ubicación). Estos datos se utilizan exclusivamente para administrar el evento, contactar a los ganadores y mejorar futuras campañas.</p>
          `
        },
        {
          title: "6. Autoridades de Supervisión",
          content: `
            <p>Puede presentar una reclamación ante las siguientes autoridades si considera que se han vulnerado sus derechos de protección de datos:</p>
            <ul>
              <li>En España: Agencia Española de Protección de Datos (AEPD) – <a href="https://www.aepd.es" target="_blank">www.aepd.es</a></li>
              <li>En el Reino Unido: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
              <li>En la Unión Europea: puede encontrar la autoridad nacional correspondiente de su país en el sitio del Comité Europeo de Protección de Datos (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ],
  footer: `
    <p>© 2025 DANGHUAN EUROPE S.L. Todos los derechos reservados.<br>
    Versión de la política: v1.0 | Última actualización: 30/05/2025</p>
  `
};